import script from "./FAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=473b7f82&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src654644659/src/thevillageongreenwayapts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-473b7f82"]])

export default __exports__